import DummyBridge from './DummyBridge';

let b = new DummyBridge();

let isBridgeAvailable = false;

export const initBridge = () => {
    console.log('init bridge func');
    try {
        // eslint-disable-next-line no-undef, @typescript-eslint/ban-ts-comment
        // @ts-ignore
        b = new Bridge();
        isBridgeAvailable = true;
    } catch (e) {
        console.log('Bridge not available');
        b = new DummyBridge();
        isBridgeAvailable = false;
    }

    return isBridgeAvailable;
};

const getB = (): DummyBridge => {
    if (!isBridgeAvailable) {
        // retry
        initBridge();
    }
    return b;
};

export default getB;
